export default __webpack_public_path__ + "static/media/cif-mu.538b1f47.svg";